import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import ReactDayPicker, { DateUtils, LocaleUtils } from "react-day-picker";

import Heading from '../Common/Heading';
import Subheading from '../Common/Subheading';

import 'react-day-picker/lib/style.css';
import './DaySelector.css';
import '../../fixed-header-view.css';

export default class DaySelector extends Component {
    static propTypes = {
        selectedDate: PropTypes.object.isRequired,
        setDate: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = { currentMonth: this.props.selectedDate.toDate() };
        this.handleDayClick = this.handleDayClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.selectedDate.isSame(nextProps.selectedDate)) {
            this.setState({ currentMonth: nextProps.selectedDate.toDate() });
        }
    }

    handleDayClick(e, day, { disabled }) {
        if (disabled)
            return;
        this.props.setDate(moment(day));
    }

    formatMonthTitle(d, locale) {
        return moment(d).format(`MMMM`);
    }

    formatWeekdayShort(i, locale) {
        return moment(i, `d`).format(`dd`).toUpperCase();
    }

    render() {
        return (
            <div className="fixed-header-view">
                <Heading title="Select start date" />
                <Subheading title={this.props.selectedDate.format(`ddd D MMM`)} />
                <div className="day-picker content">
                    <ReactDayPicker
                        selectedDays={day => DateUtils.isSameDay(this.props.selectedDate.toDate(), day)}
                        disabledDays={DateUtils.isPastDay}
                        onDayClick={this.handleDayClick}
                        initialMonth={this.state.currentMonth}
                        localeUtils={{
                            ...LocaleUtils,
                            // Override default behaviour to hide Year and uppercase Weekday
                            formatMonthTitle: this.formatMonthTitle,
                            formatWeekdayShort: this.formatWeekdayShort,
                        }}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Create/DaySelector.jsx